// Contact + brand constants
export const BRAND = {
    name: "Custom Clearance Partner",
    shortName: "CCP",
    tagline: "India's Customs & Last-Mile Partner for Global Forwarders",
    domain: "customclearancepartner.in",
};

export const CONTACT = {
    phoneDisplay: "+91 78003 20078",
    phoneRaw: "+917800320078",
    telHref: "tel:+917800320078",
    whatsappHref:
        "https://wa.me/917800320078?text=Hello%2C%20I%27d%20like%20to%20request%20customs%20clearance%20assistance.",
    email: "jaisyatharth@gmail.com",
    emailHref: "mailto:jaisyatharth@gmail.com",
    address: {
        line1: "C4 207, Eco Village 1",
        city: "Greater Noida",
        state: "Uttar Pradesh",
        pincode: "201306",
        country: "India",
    },
};

export const SERVICES = [
    {
        id: "air-express",
        code: "01",
        name: "Air Express Customs Clearance",
        short: "Bonded pickup, HAWB filing, and door delivery in under 24 hours at DEL, BOM, BLR, MAA, HYD, CCU.",
        long:
            "24/7 clearance of air-express shipments at all major Indian airports for global forwarders. HAWB filing, courier bill of entry, examination, duty payment on your behalf, and immediate release into our last-mile network.",
        bullets: [
            "IGI (DEL) Courier Terminal presence",
            "All-India CHA license coverage",
            "Duty payment on our credit",
            "Real-time WhatsApp status per HAWB",
        ],
        seoKeyword: "air express customs clearance India",
    },
    {
        id: "last-mile",
        code: "02",
        name: "Last Mile Delivery in India",
        short: "19,000+ pincodes. Bonded truck, air, and surface. Signed POD in your inbox within hours of delivery.",
        long:
            "End-to-end nationwide door delivery once cargo is cleared. Cash-on-delivery, reverse logistics, undelivered handling, and pincode-level ETA tracking for forwarders and e-commerce brands.",
        bullets: [
            "Pincode coverage across 28 states + UTs",
            "Digital signed POD returned in <6 hrs",
            "Reverse pickup and RTO handling",
            "Cold-chain and dangerous goods on request",
        ],
        seoKeyword: "last mile delivery India for forwarders",
    },
    {
        id: "baggage",
        code: "03",
        name: "Luggage & Baggage Clearance",
        short: "Unaccompanied baggage, personal effects, and transferee household clearance under TR/UB rules.",
        long:
            "For NRIs, students, and expats shipping personal effects into India — we handle TR (Transfer of Residence) baggage, unaccompanied baggage rules, exemption filings, and last-mile door delivery of household goods.",
        bullets: [
            "TR/UB filings under Baggage Rules 2016",
            "Duty exemption and duty-free entitlement checks",
            "Warehousing at Greater Noida bonded facility",
            "Handled 4,200+ personal-effect shipments",
        ],
        seoKeyword: "unaccompanied baggage clearance India",
    },
    {
        id: "forwarder",
        code: "04",
        name: "Forwarder Partnership Desk",
        short: "White-label India desk for overseas freight forwarders. One point of contact for every India destination.",
        long:
            "Extend your India operations with a dedicated CHA + delivery partner. We operate as your India desk — quoting, filing, clearing, and delivering under your brand with full status visibility.",
        bullets: [
            "Dedicated ops manager per account",
            "Milestone status pushed via EDI or email",
            "Credit terms available on volume",
            "Serving forwarders in 40+ countries",
        ],
        seoKeyword: "India customs partner for freight forwarders",
    },
];

export const PROCESS_STEPS = [
    {
        step: "01",
        title: "Pre-Alert Received",
        body: "You send us the MAWB/HAWB pre-alert with commercial invoice and packing list. Our desk acknowledges within 15 minutes, 24/7.",
    },
    {
        step: "02",
        title: "Filing & Assessment",
        body: "We file the Bill of Entry / Courier BE at ICEGATE, classify HSN correctly, and pre-negotiate examination with the appraiser.",
    },
    {
        step: "03",
        title: "Duty & Release",
        body: "Duty paid on our credit against your PO. Physical exam completed. Out-of-charge (OOC) obtained the same working day for compliant cargo.",
    },
    {
        step: "04",
        title: "Last-Mile Handover",
        body: "Bonded transfer to our facility, sorted by pincode, and pushed to our last-mile fleet. Signed POD returned to you within hours.",
    },
];

export const WHY_US_REASONS = [
  {
    n: "01",
    headline: "We answer within 15 minutes. Any hour. Any day.",
    proof:
      "Every WhatsApp or email hits a live human on our operations desk in <15 minutes — measured across 12,400+ shipments last year. Nights, weekends, festivals included.",
    metric: "15 min",
    metricLabel: "median first response",
  },
  {
    n: "02",
    headline: "You get a named ops manager, not a call-centre queue.",
    proof:
      "On onboarding you're assigned a dedicated ops manager who owns your forwarder account, learns your HSN patterns, and picks up when you WhatsApp them directly. No ticket numbers.",
    metric: "1:1",
    metricLabel: "dedicated ops per forwarder",
  },
  {
    n: "03",
    headline: "Median clearance under 6 hours at IGI Delhi.",
    proof:
      "Compliant air-express shipments are cleared in <6 hours (median). eSANCHIT pre-filed, HSN pre-classified, examiner pre-briefed — before the flight even lands.",
    metric: "< 6 hrs",
    metricLabel: "median IGI clearance",
  },
  {
    n: "04",
    headline: "99.2% first-time exam pass rate.",
    proof:
      "Not because we ignore rules — because we file them precisely. HSN, valuation, and licence checks are done at pre-alert stage. Almost zero reassessments, almost zero DDs.",
    metric: "99.2%",
    metricLabel: "first-time exam pass",
  },
  {
    n: "05",
    headline: "We pay Indian duty on our credit.",
    proof:
      "Your cargo isn't held up waiting for a bank wire. We settle duty via our credit line at ICEGATE and invoice you on your standard credit terms — SWIFT, wire, or via consignee.",
    metric: "$$",
    metricLabel: "duty settled on our credit",
  },
  {
    n: "06",
    headline: "Signed POD in your inbox within 6 hours of delivery.",
    proof:
      "Digital signed proof-of-delivery, GPS-timestamped, pushed to your ops inbox or EDI within a few hours of last-mile completion. No 'we'll email tomorrow'.",
    metric: "< 6 hrs",
    metricLabel: "signed POD returned",
  },
  {
    n: "07",
    headline: "NDA-first. Your customers stay yours.",
    proof:
      "Every forwarder engagement starts with a mutual NDA. We never contact your end-consignee, never mention our brand on shipping documents, never solicit your customers.",
    metric: "NDA",
    metricLabel: "signed on day one",
  },
  {
    n: "08",
    headline: "Any commodity. Any airport. One point of contact.",
    proof:
      "Instead of coordinating a CHA + trucker + courier + customs consultant for each shipment, you get all four functions under one WhatsApp thread with one ops manager.",
    metric: "1",
    metricLabel: "point of contact",
  },
];

export const GUARANTEES = [
  {
    title: "No clearance, no fee",
    body:
      "If a shipment isn't cleared due to our error, we waive our brokerage fee on that consignment. Zero questions asked.",
  },
  {
    title: "15-minute response SLA — 24/7",
    body:
      "Written into every forwarder MSA. Miss the SLA, we credit 10% of that month's brokerage back to you.",
  },
  {
    title: "In-transit cargo insurance available",
    body:
      "Optional cargo insurance up to full CIF value from tarmac to consignee door — arranged in one email, no separate broker.",
  },
  {
    title: "Data confidentiality — GDPR-aligned",
    body:
      "Shipment data is kept on India-hosted infrastructure, access-controlled, and purged 24 months post-close. Ask for our data-processing addendum.",
  },
  {
    title: "Same-day duty settlement",
    body:
      "Duty paid on our credit line the same working day as OOC — even for high-value electronics or pharma shipments.",
  },
  {
    title: "Escalation to founder in 60 minutes",
    body:
      "Any unresolved issue after 60 minutes escalates directly to the founder's mobile. You'll rarely need this — but it's yours if you do.",
  },
];

export const COMPLIANCE_STACK = [
  {
    label: "CBLR 2018",
    desc: "Licensed Customs Broker under Customs Brokers Licensing Regulations 2018.",
  },
  {
    label: "ICEGATE",
    desc: "Registered ICEGATE user with eSANCHIT electronic document submission.",
  },
  {
    label: "AEO-Compliant",
    desc: "Documentation workflows aligned to Authorised Economic Operator standards.",
  },
  {
    label: "DGCA-Regulated",
    desc: "Air-side operations follow DGCA safety and handling regulations.",
  },
  {
    label: "IATA / FIATA network",
    desc: "Operates within the IATA and FIATA freight forwarder networks worldwide.",
  },
  {
    label: "Baggage Rules 2016",
    desc: "Specialised in Transfer of Residence and Unaccompanied Baggage clearance.",
  },
  {
    label: "GST-registered",
    desc: "GSTIN-registered and invoicing-compliant across Indian states.",
  },
  {
    label: "MSME-registered",
    desc: "Registered under India's Ministry of Micro, Small & Medium Enterprises.",
  },
];

export const WHY_US = [
    { stat: "12,400+", label: "Shipments cleared this year" },
    { stat: "19,000+", label: "Serviceable Indian pincodes" },
    { stat: "40+", label: "Forwarder countries served" },
    { stat: "24/7", label: "Operations desk availability" },
    { stat: "< 6 hrs", label: "Median clearance turnaround" },
    { stat: "99.2%", label: "First-time exam pass rate" },
];

export const TRUST_MARKERS = [
    "LICENSED CUSTOMS HOUSE AGENT",
    "NO IEC / FSSAI / BIS NEEDED FROM YOU",
    "IGI COURIER TERMINAL PRESENCE",
    "DGCA-REGULATED PROCESSES",
    "IATA-FIATA NETWORK PARTNERS",
    "ICEGATE eSANCHIT ENABLED",
    "AEO-COMPLIANT DOCUMENTATION",
    "GST & TR BAGGAGE SPECIALISTS",
];

export const CASE_STUDIES = [
    {
        docket: "CCP-2025-AX-1187",
        origin: "Frankfurt (FRA)",
        destination: "Bengaluru (BLR)",
        cargo: "Semiconductor spares, 42 kg",
        forwarder: "German freight forwarder",
        turnaround: "5h 40m",
        outcome:
            "Filed courier BE, cleared at BLR courier terminal, delivered to Whitefield MRO within same working day.",
    },
    {
        docket: "CCP-2025-UB-0934",
        origin: "Toronto (YYZ)",
        destination: "Chandigarh (IXC)",
        cargo: "Unaccompanied baggage, 6 pieces / 187 kg",
        forwarder: "Canadian relocation agent",
        turnaround: "38h",
        outcome:
            "TR-filed baggage cleared with duty exemption under Baggage Rules 2016; last-mile door delivery to Mohali residence.",
    },
    {
        docket: "CCP-2025-EC-2214",
        origin: "Shenzhen (SZX)",
        destination: "Pan-India (14 pincodes)",
        cargo: "Consumer electronics, 812 SKUs",
        forwarder: "Hong Kong e-commerce forwarder",
        turnaround: "11h + 48h delivery",
        outcome:
            "Consolidated import, courier BE filed, sorted at Greater Noida hub, dispatched to 14 pincodes with signed PODs.",
    },
    {
        docket: "CCP-2025-AX-1902",
        origin: "Dubai (DXB)",
        destination: "Mumbai (BOM)",
        cargo: "Fashion samples, 3 HAWBs",
        forwarder: "UAE freight forwarder",
        turnaround: "4h 15m",
        outcome:
            "Priority clearance at BOM courier terminal, direct hand-off at BKC for buyer meeting within 5 hours of landing.",
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "CCP has been our India desk for two years. Clearance times we couldn't achieve with tier-1 carriers are now routine. Their WhatsApp updates per HAWB genuinely changed the way we quote India lanes.",
        author: "Operations Director",
        company: "European air-express forwarder",
    },
    {
        quote:
            "We route every unaccompanied baggage shipment to India through CCP. Baggage Rules paperwork is airtight, and their team walks our customer through duty computation personally.",
        author: "Relocation Manager",
        company: "North American moving company",
    },
    {
        quote:
            "First-time exam pass rate above 99% — that number is real for us. Their HSN classification discipline is the reason we never see reassessment queries.",
        author: "Compliance Head",
        company: "Southeast Asian consolidator",
    },
    {
        quote:
            "For e-commerce imports, CCP consolidates, clears, sorts by pincode, and gets a signed POD back to us within 60 hours end-to-end. Nothing else on the market does this.",
        author: "Founder",
        company: "Cross-border D2C brand",
    },
];

export const FAQS = [
    {
        q: "Do I need my own import licence (IEC / FSSAI / BIS) to import goods to India through Custom Clearance Partner?",
        a: "No. Custom Clearance Partner imports against our own licence portfolio — IEC (Importer-Exporter Code), FSSAI (for food), BIS (for electronics), WPC (for wireless devices), and CDSCO (for medical / cosmetics) — and delivers to your Indian address as a private consignee. You do not need to acquire any Indian import licence yourself. This is a legal, industry-standard model that licensed India CHAs operate. Perfect for individuals, dropshippers, first-time importers, small e-commerce sellers, and restaurants introducing imported items to their menu.",
    },
    {
        q: "What is a customs house agent (CHA) and why do I need one to import into India?",
        a: "A Customs House Agent (also called Customs Broker) is licensed by Indian Customs under the CBLR 2018 to file Bills of Entry, classify goods under the correct HSN, pay duties, and obtain the Out-of-Charge order. Any commercial or personal shipment landing in India must be cleared by an authorised person — most global forwarders appoint a CHA like Custom Clearance Partner to represent the consignee locally.",
    },
    {
        q: "How fast can you clear an air-express shipment at Delhi (DEL) airport?",
        a: "For compliant shipments with complete documentation received before the flight lands, our median clearance time at IGI Delhi Courier Terminal is under 6 hours. Cargo received before 10:00 AM is typically out for last-mile delivery the same working day.",
    },
    {
        q: "Do you handle unaccompanied baggage and Transfer of Residence (TR) clearance?",
        a: "Yes. We are specialists in Baggage Rules 2016 clearance including Transfer of Residence, unaccompanied baggage, and personal effect shipments for NRIs, students, and expats. We handle duty-exemption filings, warehousing at our Greater Noida bonded facility, and door delivery anywhere in India.",
    },
    {
        q: "Which Indian airports and cities do you cover?",
        a: "Customs clearance: Delhi (DEL), Mumbai (BOM), Bengaluru (BLR), Chennai (MAA), Hyderabad (HYD), Kolkata (CCU), and Cochin (COK). Last-mile delivery: 19,000+ pincodes across all 28 states and 8 union territories.",
    },
    {
        q: "Can I pay Indian import duty through you?",
        a: "Yes. We settle customs duty on our credit line at ICEGATE and invoice you on your standard credit terms. Payment can be by SWIFT, wire, or via your India-based consignee.",
    },
    {
        q: "What documents do you need to start clearance?",
        a: "For commercial shipments: HAWB/MAWB, commercial invoice, packing list, KYC of consignee, IEC code (if applicable), and any product-specific licences (BIS, FSSAI, WPC, drug licence, etc.). For baggage: passport copy, passenger declaration, and OCI/employment proof for TR cases.",
    },
    {
        q: "Are you AEO-certified or DGCA-approved?",
        a: "We operate under a licensed customs broker in AEO-compliant documentation workflows and follow DGCA-regulated processes for air-side handling. Certification details are shared privately during onboarding.",
    },
    {
        q: "Do you clear all types of cargo and commodities?",
        a: "Yes. We clear any commodity that is legally importable into India — including electronics, pharmaceuticals, machinery, automotive spares, textiles, fashion samples, food products (FSSAI), cosmetics, chemicals, DGR/hazardous cargo, cold-chain pharma, gems and jewellery, wines and spirits, project cargo, EPCG-linked machinery, ATA Carnet exhibition cargo, works of art, personal effects, and unaccompanied baggage. If the cargo has a legal HSN code, we can file for it. Send us the product description on WhatsApp for HSN classification and a duty estimate.",
    },
    {
        q: "How do overseas freight forwarders partner with Custom Clearance Partner?",
        a: "Book a 15-minute intro call via WhatsApp or phone. We onboard forwarders with a mutual NDA, credit terms, EDI or email milestone setup, and a dedicated ops manager. We have active partnerships in over 40 countries.",
    },
    {
        q: "How much does customs clearance cost in India for a freight forwarder?",
        a: "Air-express customs clearance for a standard commercial shipment starts around INR 3,500-5,500 per Bill of Entry, exclusive of duty, GST, and airport handling. Volume forwarders qualify for slab-based monthly billing. Personal-baggage clearance under TR is priced separately. Send us the HAWB pattern and cargo type for a firm quote — WhatsApp +91 78003 20078.",
    },
    {
        q: "What is the difference between a Customs House Agent (CHA), a Customs Broker, and a Freight Forwarder in India?",
        a: "A CHA / Customs Broker is a person or firm licensed under the Customs Brokers Licensing Regulations 2018 to file Bills of Entry, classify goods under HSN, and settle duty on behalf of an importer. A Freight Forwarder arranges international transport but is not licensed to clear customs. Custom Clearance Partner operates as a licensed CHA and last-mile provider, so global freight forwarders use us as their India desk instead of appointing a separate broker.",
    },
    {
        q: "Which is the fastest airport for customs clearance in India?",
        a: "For air-express and courier cargo, Delhi (DEL) IGI Courier Terminal offers the fastest median clearance (under 6 hours for compliant shipments), followed by Bengaluru (BLR) and Hyderabad (HYD). We can also route shipments via Mumbai (BOM), Chennai (MAA), Kolkata (CCU) or Cochin (COK) depending on the destination pincode and cargo type.",
    },
    {
        q: "Can you clear e-commerce shipments consolidated by overseas forwarders?",
        a: "Yes. We regularly clear consolidated e-commerce cargo under the Courier Bill of Entry regime, sort at our Greater Noida bonded hub by destination pincode, and dispatch nationwide via last-mile. This is the fastest legal path for cross-border D2C SKUs into India.",
    },
    {
        q: "Do you handle DGR (Dangerous Goods) and cold-chain pharmaceutical clearance?",
        a: "Yes. Pharma cold-chain lanes are supported at DEL, HYD, BOM and BLR with unbroken temperature preservation from tarmac to bonded warehouse. Dangerous Goods (DGR) shipments are handled with certified staff and appropriate storage — please share the IATA DGR class in your pre-alert.",
    },
    {
        q: "Are you a licensed Customs House Agent (CHA) in India?",
        a: "Yes. We operate under a valid CHA / Customs Broker licence issued under CBLR 2018 and are ICEGATE eSANCHIT-enabled. Licence details are shared privately during forwarder onboarding along with our AEO documentation profile.",
    },
    {
        q: "What is the difference between a Bill of Entry and a Courier Bill of Entry?",
        a: "A Bill of Entry (BE) is the standard customs document for commercial imports filed at ICEGATE — used for cargo above the courier weight/value threshold or requiring specific licences. A Courier Bill of Entry (CBE) is a simplified regime for low-value, low-weight air-express shipments processed at Courier Terminals. We advise on the correct regime per shipment to minimise duty and turnaround.",
    },
];

export const PORTS = [
  {
    code: "DEL",
    city: "Delhi (IGI)",
    type: "Air Cargo + Courier Terminal",
    ops: "24/7 Air Express, Courier BE, Commercial Cargo",
    keyword: "Delhi customs clearance agent",
  },
  {
    code: "BOM",
    city: "Mumbai (CSMIA)",
    type: "Air Cargo + Courier Terminal",
    ops: "Air Freight, Fashion Samples, Pharma Cold Chain",
    keyword: "Mumbai customs clearance broker",
  },
  {
    code: "BLR",
    city: "Bengaluru (KIA)",
    type: "Air Cargo Terminal",
    ops: "Electronics, Semiconductor, MRO Spares",
    keyword: "Bangalore customs clearance CHA",
  },
  {
    code: "MAA",
    city: "Chennai (MAA)",
    type: "Air Cargo Terminal",
    ops: "Automotive Components, Pharma, Textiles",
    keyword: "Chennai customs clearance agent",
  },
  {
    code: "HYD",
    city: "Hyderabad (RGIA)",
    type: "Air Cargo Terminal",
    ops: "Pharma, Life Sciences, IT Hardware",
    keyword: "Hyderabad pharma customs clearance",
  },
  {
    code: "CCU",
    city: "Kolkata (NSCBI)",
    type: "Air Cargo Terminal",
    ops: "Textiles, Consumer Goods, Personal Effects",
    keyword: "Kolkata customs clearance broker",
  },
  {
    code: "COK",
    city: "Cochin (COK)",
    type: "Air Cargo Terminal",
    ops: "Spices, Seafood, Gulf Route Baggage",
    keyword: "Cochin customs clearance for Gulf forwarders",
  },
  {
    code: "TKD",
    city: "ICD Tughlakabad",
    type: "Inland Container Depot",
    ops: "Container Consolidation, Warehousing",
    keyword: "ICD Tughlakabad customs broker",
  },
];

export const COUNTRIES_SERVED = [
  { code: "DE", name: "Germany", note: "FRA · MUC → DEL/BLR pharma + MRO" },
  { code: "JP", name: "Japan", note: "NRT · HND → automotive spares + food" },
  { code: "GB", name: "United Kingdom", note: "LHR → DEL/BOM · express clearance partner" },
  { code: "KR", name: "South Korea", note: "ICN → BLR semiconductor · clearance partner" },
  { code: "VN", name: "Vietnam", note: "SGN · HAN → BOM textiles + e-com" },
  { code: "TH", name: "Thailand", note: "BKK → DEL cosmetics + auto parts" },
  { code: "RU", name: "Russia", note: "SVO → DEL specialty cargo" },
  { code: "IQ", name: "Iraq", note: "BGW → DEL medical + equipment" },
  { code: "BE", name: "Belgium", note: "BRU · LGG → BOM pharma + diamonds" },
  { code: "QA", name: "Qatar", note: "DOH → COK/DEL baggage + samples" },
  { code: "AU", name: "Australia", note: "SYD · MEL → DEL TR + personal effects" },
  { code: "US", name: "United States", note: "West + East Coast air express" },
  { code: "AE", name: "UAE", note: "DXB → BOM Gulf express" },
  { code: "SG", name: "Singapore", note: "SIN → BLR electronics" },
  { code: "HK", name: "Hong Kong", note: "HKG cross-border e-com" },
  { code: "CN", name: "China", note: "PVG · SZX e-com consols" },
  { code: "NL", name: "Netherlands", note: "AMS pharma cold chain" },
  { code: "CA", name: "Canada", note: "YYZ unaccompanied baggage" },
  { code: "SA", name: "Saudi Arabia", note: "JED Gulf-India baggage" },
  { code: "TR", name: "Türkiye", note: "IST textile lanes" },
];

export const PRIORITY_COUNTRIES = [
  {
    code: "DE",
    name: "Germany",
    flag: "🇩🇪",
    lanes: "FRA · MUC · HAM · BER → DEL / BOM / BLR",
    intent:
      "German freight forwarders and courier companies routing MRO, automotive spares, machinery, and pharma cold-chain into India rely on our sub-6-hour DEL and BLR clearance.",
    keywords:
      "Germany India freight forwarder, Deutscher Zollagent Indien, customs clearance India for German shippers, FRA to DEL air freight partner, India customs broker for German logistics companies",
  },
  {
    code: "JP",
    name: "Japan",
    flag: "🇯🇵",
    lanes: "NRT · HND · KIX → DEL / BLR / MAA",
    intent:
      "Japanese logistics companies and 3PLs shipping automotive components, electronics, and precision machinery to India get pre-cleared HSN and priority release via our desk.",
    keywords:
      "Japan India customs clearance, 日本 インド 通関, India customs broker for Japanese forwarders, NRT to DEL freight, India desk for Japanese logistics companies",
  },
  {
    code: "VN",
    name: "Vietnam",
    flag: "🇻🇳",
    lanes: "SGN · HAN → BOM / MAA / BLR",
    intent:
      "Vietnamese freight forwarders and e-commerce consolidators shipping textiles, electronics, and consumer goods into India move faster through our Courier BE regime.",
    keywords:
      "Vietnam India customs clearance, đại lý hải quan Ấn Độ, freight forwarder Vietnam to India, India customs partner for Vietnamese shippers, SGN to BOM air freight",
  },
  {
    code: "TH",
    name: "Thailand",
    flag: "🇹🇭",
    lanes: "BKK · DMK → DEL / BOM / MAA",
    intent:
      "Thai logistics companies and couriers exporting auto parts, gemstones, cosmetics, and packaged food to India use our licensed CHA desk for FSSAI + BIS clearance.",
    keywords:
      "Thailand India customs clearance, พิธีการศุลกากรอินเดีย, freight forwarder Thailand to India, India customs broker for Thai logistics, BKK to DEL air freight",
  },
  {
    code: "RU",
    name: "Russia",
    flag: "🇷🇺",
    lanes: "SVO · DME → DEL / BOM",
    intent:
      "Russian shippers and freight forwarders moving spare parts, chemicals, and specialty cargo into India use our desk for compliant sanctions-safe clearance and pincode delivery.",
    keywords:
      "Russia India customs clearance, таможенное оформление в Индии, freight forwarder Russia to India, India customs broker for Russian logistics companies, SVO to DEL air freight",
  },
  {
    code: "IQ",
    name: "Iraq",
    flag: "🇮🇶",
    lanes: "BGW · BSR · EBL → DEL / BOM",
    intent:
      "Iraqi importers, medical suppliers, and freight forwarders shipping equipment and consumables into India get responsive Arabic/English support via WhatsApp and one-point clearance.",
    keywords:
      "Iraq India customs clearance, تخليص جمركي الهند, freight forwarder Iraq to India, India customs broker for Iraqi companies, Baghdad to Delhi air freight",
  },
  {
    code: "BE",
    name: "Belgium",
    flag: "🇧🇪",
    lanes: "BRU · LGG → DEL / BOM / BLR",
    intent:
      "Belgian freight forwarders (Liège hub) shipping pharma, diamonds, fine art, and industrial cargo into India get white-glove clearance and museum-grade last-mile.",
    keywords:
      "Belgium India customs clearance, douane-inklaring India, freight forwarder Belgium to India, India customs broker for Belgian logistics, Liège to Delhi air freight",
  },
  {
    code: "QA",
    name: "Qatar",
    flag: "🇶🇦",
    lanes: "DOH → DEL / BOM / COK / MAA",
    intent:
      "Qatari couriers and freight forwarders on the Doha-India lane (baggage, personal effects, business samples) route via our Cochin and Delhi desks with Gulf-specific care.",
    keywords:
      "Qatar India customs clearance, تخليص جمركي الهند من قطر, freight forwarder Qatar to India, DOH to COK unaccompanied baggage, India customs broker for Qatari logistics",
  },
  {
    code: "AU",
    name: "Australia",
    flag: "🇦🇺",
    lanes: "SYD · MEL · PER → DEL / BOM / MAA",
    intent:
      "Australian relocation agents, freight forwarders, and shippers moving unaccompanied baggage, wines, machinery, and personal effects into India rely on our TR-baggage expertise.",
    keywords:
      "Australia India customs clearance, freight forwarder Australia to India, India customs broker for Australian relocation agents, SYD to DEL unaccompanied baggage clearance, Transfer of Residence Australia to India",
  },
  {
    code: "GB",
    name: "United Kingdom",
    flag: "🇬🇧",
    lanes: "LHR · STN · MAN → DEL / BOM / BLR",
    intent:
      "UK express companies, e-commerce brands, and freight forwarders — we operate as your India clearance partner. Fashion samples, tech, pharma, and unaccompanied baggage cleared under 6 hours at IGI Delhi.",
    keywords:
      "UK to India express clearance partner, UK freight forwarder India customs, London Heathrow to Delhi customs broker, UK ecommerce shipping India, India customs partner for British couriers, DHL UK to India alternative",
  },
  {
    code: "KR",
    name: "South Korea",
    flag: "🇰🇷",
    lanes: "ICN · GMP → BLR / DEL / MAA",
    intent:
      "South Korean express companies and freight forwarders shipping semiconductors, electronics, K-beauty, and automotive components to India rely on our licensed CHA for BIS + WPC compliance and sub-8-hour BLR clearance.",
    keywords:
      "South Korea to India express clearance partner, Korea freight forwarder India customs, ICN Incheon to Bengaluru semiconductor clearance, K-beauty India customs, Korean electronics India customs partner",
  },
];

export const COMMODITIES = [
  {
    name: "Electronics & Semiconductors",
    detail: "BIS + WPC compliant clearance. HSN 8471, 8517, 8542. Anti-static handling in bonded transit.",
  },
  {
    name: "Pharmaceuticals & Life Sciences",
    detail: "CDSCO + Drug Controller filings, cold-chain-preserved lane from tarmac to bonded warehouse.",
  },
  {
    name: "Fashion Samples & Luxury",
    detail: "Pre-cleared HSN, priority courier BE, direct hand-off at BKC/CP/UB City buyer meetings.",
  },
  {
    name: "Automotive Spares & MRO",
    detail: "Time-critical AOG shipments cleared at DEL/BLR/MAA within hours of touchdown.",
  },
  {
    name: "E-Commerce Consolidations",
    detail: "Courier Bill of Entry regime, pincode-sortation, signed POD to 19,000+ pincodes.",
  },
  {
    name: "Machinery & Industrial",
    detail: "EPCG-aware classification, project cargo handling, duty deferment via warehousing.",
  },
  {
    name: "Personal Effects & Household",
    detail: "Transfer of Residence (TR) under Baggage Rules 2016, duty exemption, door delivery.",
  },
  {
    name: "Fine Art & Exhibition Cargo",
    detail: "ATA Carnet clearance, temporary import bonds, museum-grade white-glove last mile.",
  },
];

export const INSIGHTS = [
    {
        tag: "Regulations",
        title: "Baggage Rules 2016: What NRIs need to know before shipping personal effects to India",
        excerpt:
            "A field guide to Transfer of Residence, duty-free entitlements, and documentation for unaccompanied baggage clearance in India.",
        readTime: "8 min read",
    },
    {
        tag: "Air Express",
        title: "Cutting DEL clearance time from 24 hours to 6: an ops teardown",
        excerpt:
            "How pre-filing at ICEGATE, HSN precision, and appraiser negotiation compress air-express clearance timelines for global forwarders.",
        readTime: "6 min read",
    },
    {
        tag: "E-Commerce",
        title: "Consolidated cross-border imports: courier BE vs. Bill of Entry",
        excerpt:
            "When e-commerce forwarders should choose the courier BE regime versus a standard Bill of Entry — with a duty-cost comparison.",
        readTime: "9 min read",
    },
    {
        tag: "Forwarder Guide",
        title: "The India desk playbook for overseas freight forwarders",
        excerpt:
            "A repeatable operating model for extending your forwarding brand into India via a local CHA + last-mile partner.",
        readTime: "11 min read",
    },
];
